import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import SVG from 'react-inlinesvg';

import { socialLinks} from '../../lib/appConfig';

import fbSvgIcon from "../../assets/footer/fb.svg";
import igSvgIcon from "../../assets/footer/ig.svg";
import ytSvgIcon from "../../assets/footer/yt.svg";
import githubSvgIcon from "../../assets/footer/github.svg";
import tlSvgIcon from "../../assets/footer/telegram.svg";
import mstdnSvgIcon from "../../assets/footer/mastodon.svg"
import SubscriptionForm from '../misc/SubscriptionForm';
import { appState } from '../../lib/appConfig';

const SiteFooter = props => {
  const { t, routes } = props;

  return (
    <footer>
      <section className='top'>
        <div className='container'>
          <div className='row'>
            <div className='col-sm-12 col-md-4'>
              {
                !appState.isUnderMaintenance && <SubscriptionForm t={t}/>
              }
            </div>
            <div className='col-max-until-xm col-sm'>
              <h3>{t('footerSectionsExplore')}</h3>
              <ul>
                <li>
                  <Link to={routes.home}>{t('navbarHome')}</Link>
                </li>
                <li>
                  <Link to={routes.posts.list}>{t('navbarPosts')}</Link>
                </li>
                <li>
                  <Link to={routes.news.list}>{t('navbarNews')}</Link>                
                </li>
                <li>
                  <Link to={routes.tutorials.list}>{t('navbarTutorials')}</Link>
                </li>
                <li>
                  <Link to={routes.videos}>{t('navbarVideos')}</Link>
                </li>
              </ul>
            </div>
            <div className='col-max-until-xm col-sm'>
              <h3>{t('footerSectionsDownloads')}</h3>
              <ul>
                <li>
                  <Link to={routes.mods}>{t('navbarMods')}</Link>
                </li>
                <li>
                  <Link to={routes.software}>{t('navbarSoftware')}</Link>
                </li>
              </ul>
            </div>
            <div className='col-max-until-xm col-sm'>
              <h3>{t('footerSectionsQuickLinks')}</h3>
              <ul>
                <li>
                  <Link to={routes.contactInfo}>{t('footerQuickLinksAboutContactText')}</Link>
                </li>
                <li>
                  <Link to={routes.privacypolicy}>{t('footerQuickLinksPrivacyPolicyText')}</Link>
                </li>
                <li>
                  <Link to={routes.sitemap}>{t('footerQuickLinksSiteMapText')}</Link>
                </li>
                {/* TODO AND NOTE: Re-Enable report issue link when backend is ready */}
                {/* <li>
                  <Link to={routes.report}>{t('footerQuickLinksReportIssueText')}</Link>
                </li> */}
              </ul>
            </div>
          </div>
        </div>
        <div className='container socialmedia'>
          <div className='responsive-margin'>
            <a href={socialLinks.youtube} target='_blank' rel='noreferrer'>
              <SVG src={ytSvgIcon}/>
            </a>
            {/* <a href={socialLinks.instagram} target='_blank' rel='noreferrer'>
              <SVG src={igSvgIcon}/>  
            </a> */}
            {/* <a href={socialLinks.facebook} target='_blank' rel='noreferrer'>
              <SVG src={fbSvgIcon}/> 
            </a> */}
            {/* <a href={socialLinks.mastodon} target='_blank' rel='noreferrer'>
              <SVG src={mstdnSvgIcon}/>
            </a> */}
            <a href={socialLinks.github} target='_blank' rel='noreferrer'>
              <SVG src={githubSvgIcon}/>  
            </a>
            {/* <a href={socialLinks.telegram} target='_blank' rel='noreferrer'>
              <SVG src={tlSvgIcon}/>
            </a> */}
          </div>
        </div>
      </section>
      <section className='bottom'>
        <small>&copy; Copyright 2026, Spooky Bytes, {t('footerRightsMessage')}.</small>
      </section>
    </footer>
  );
};

export default withRouter(SiteFooter);
